(function () {
  'use strict';

  const rootSelector = '[data-motorbike-hub]';
  const hiddenClass = 'mbhub-is-hidden';

  function splitYearLabels(value) {
    return String(value || '')
      .split('|')
      .map(function (token) { return token.trim(); })
      .filter(Boolean);
  }

  function yearNumber(value) {
    const match = String(value || '').match(/\d{4}/);
    return match ? parseInt(match[0], 10) : null;
  }

  function decadeKey(value) {
    if (value === 'all') return 'all';
    const year = yearNumber(value);
    if (!year) return 'other';
    return String(Math.floor(year / 10) * 10);
  }

  function parseRange(value) {
    const raw = String(value || '').trim().replace(/–/g, '-').replace(/—/g, '-');

    if (!raw || raw === 'all') {
      return { all: true, exact: null, min: null, max: null };
    }

    if (raw.indexOf('+') !== -1) {
      const min = yearNumber(raw);
      return { all: false, exact: null, min: min || 0, max: 3000 };
    }

    const matches = raw.match(/\d{4}/g) || [];

    if (raw.indexOf('-') !== -1 && matches.length >= 2) {
      return {
        all: false,
        exact: null,
        min: parseInt(matches[0], 10),
        max: parseInt(matches[1], 10)
      };
    }

    return { all: false, exact: raw, min: null, max: null };
  }

  function cardMatchesRange(card, range) {
    if (range.all) return true;

    const yearLabels = splitYearLabels(card.getAttribute('data-mbhub-years'));

    if (!yearLabels.length) {
      return true;
    }

    if (range.exact) {
      return yearLabels.indexOf(range.exact) !== -1;
    }

    return yearLabels.some(function (label) {
      const year = yearNumber(label);
      return year && year >= range.min && year <= range.max;
    });
  }

  function updateSectionVisibility(root) {
    root.querySelectorAll('[data-mbhub-product-section]').forEach(function (section) {
      const visibleCards = section.querySelectorAll('[data-mbhub-card]:not(.' + hiddenClass + ')');
      section.classList.toggle(hiddenClass, visibleCards.length === 0);
    });
  }

  function updateCounts(root) {
    root.querySelectorAll('[data-mbhub-product-section]').forEach(function (section) {
      const countEl = section.querySelector('[data-mbhub-visible-count]');
      if (!countEl) return;
      const count = section.querySelectorAll('[data-mbhub-card]:not(.' + hiddenClass + ')').length;
      countEl.textContent = count;
    });
  }

  function setActiveYear(root, value) {
    root.querySelectorAll('[data-mbhub-year-option]').forEach(function (button) {
      const active = button.getAttribute('data-mbhub-year-option') === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const select = root.querySelector('[data-mbhub-year-select]');
    if (select && select.value !== value) {
      select.value = value;
    }
  }

  function applyFilter(root, value) {
    const range = parseRange(value);

    root.querySelectorAll('[data-mbhub-card]').forEach(function (card) {
      card.classList.toggle(hiddenClass, !cardMatchesRange(card, range));
    });

    setActiveYear(root, value);
    updateCounts(root);
    updateSectionVisibility(root);
  }

  function groupYearButtons(root) {
    const holder = root.querySelector('[data-mbhub-year-options]');
    if (!holder || holder.dataset.mbhubGrouped === 'true') return;

    const buttons = Array.prototype.slice.call(holder.querySelectorAll('[data-mbhub-year-option]'));
    if (!buttons.length) return;

    holder.innerHTML = '';

    const rows = {};
    const rowOrder = [];

    buttons.forEach(function (button) {
      const value = button.getAttribute('data-mbhub-year-option');
      const key = decadeKey(value);
      if (!rows[key]) {
        rows[key] = document.createElement('div');
        rows[key].className = 'mbhub-year__row mbhub-year__row--' + key;
        rowOrder.push(key);
      }
      rows[key].appendChild(button);
    });

    rowOrder.forEach(function (key) {
      holder.appendChild(rows[key]);
    });

    holder.dataset.mbhubGrouped = 'true';
  }

  function init(root) {
    if (!root || root.dataset.motorbikeHubInitialised === 'true') return;
    root.dataset.motorbikeHubInitialised = 'true';

    groupYearButtons(root);

    const buttons = root.querySelectorAll('[data-mbhub-year-option]');
    const select = root.querySelector('[data-mbhub-year-select]');

    if (!buttons.length && !select) {
      updateCounts(root);
      updateSectionVisibility(root);
      return;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(root, button.getAttribute('data-mbhub-year-option'));
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        applyFilter(root, select.value);
      });
    }

    const defaultButton = root.querySelector('[data-mbhub-default-year="true"]') || buttons[0];
    applyFilter(root, defaultButton ? defaultButton.getAttribute('data-mbhub-year-option') : 'all');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(rootSelector).forEach(init);
  });
})();
